import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Observable} from 'rxjs';
import {OfferDtoModel, OfferHolderModel} from '../models/offer.dto.model';

@Injectable({
    providedIn: 'root'
})
export class OffreService {

    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/offer`;
    }

    public getOffersByPartnerUuid(uuid: string): Observable<OfferDtoModel[]> {
        return this.http.get<OfferDtoModel[]>(`${this.baseUrl}` + '/partner/' + uuid);
    }

    public persistOffer(offer: OfferHolderModel): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}`, offer);

    }

    public updateOffer(selectedOffer: OfferDtoModel): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}`, selectedOffer);
    }

    public deleteOffer(offerUuid: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${offerUuid}`);
    }

    public getOffersByConnectedUser(): Observable<OfferDtoModel[]> {
        return this.http.get<OfferDtoModel[]>(`${this.baseUrl}` + '/user');
    }

    public sendMailToAdmin(): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/update-request`, null);

    }

}
